/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamSchvalovaciSablonaEpkUkony extends GContentBase<SeznamSchvalovaciSablonaEpkUkonyObj> {
        private seznamObj: SeznamSchvalovaciSablonaEpkUkonyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamSchvalovaciSablonaEpkUkonyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamSchvalovaciSablonaEpkUkonyNew",
                contentCaption: "jres:33000903", //RC 33000903 : Úkony schvalovacího šablony
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ssa} - {radek_sab}"
                },
                gridSettings: {
                    columnOrder: "radek_sab,ixs_sro_txt,sch_pov_txt,sch_uroven,typ_pozad_pod_txt,typ_pozad_pod_pozn,dnu_pozad,nazev_ukon,hodin_poz_abs,priz_den_poz_prac_txt,priz_edit_termin_txt,priz_opak_txt,id_alg,ktg_sch_role_txt,priz_opa_txt,ixs_dpo_txt,stav_schvproc_txt,dat_zmena,zmenu_prov_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamSchvalovaciSablonaEpkUkonyObj extends GAdmSeznamBase {
        ixs_ssa: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailSchvalovaciSablonaEpkUkony", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailSchvalovaciSablonaEpkUkony",
                newRecord: isNew,
                ixs_ssa: isNew == true ? (this.ixs_ssa ? this.ixs_ssa : null) : data.ixs_ssa,
                radek_sab: isNew == true ? null : data.radek_sab
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"/*, "actOpenDialogVyberovaSkupina*"*/]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"/*, "actOpenDialogVyberovaSkupina*"*/])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131057").addField("gselectbox", Gordic.Prefabs.Select.wflsssa(), {
                    name: "ixs_ssa",
                    model: "model.ixs_ssa=value.ixs_ssa",
                    dropdown: true,
                    disabled: (this.ixs_ssa) ? true : false
                })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_ssa)
                hardFilter["ixs_ssa"] = this.ixs_ssa;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_ssa)
                data["ixs_ssa"] = this.ixs_ssa;
        }

        applydata(filterData: any) {
            this.cnt.isl.SchvalovaciSablonaEpkUkony.list({ filters: filterData }).getView().then((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_ssa}#${data.radek_sab}#`,
                nazev: `${data.ixs_ssa_txt} - ${data.radek_sab}`
            }
        }
    }
}